module.exports = __webpack_public_path__ + "img/17-1.523e9b09.png";